import { render, staticRenderFns } from "./messageCenter.vue?vue&type=template&id=1f828428&"
import script from "./messageCenter.vue?vue&type=script&lang=js&"
export * from "./messageCenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports